import React, { useState, useMemo } from 'react'

import { PropertyAnnouncement } from 'types/propertyAnnouncement'
import WarrantySelector from 'components/WarrantySelector'
import IconBoxSelect from 'components/IconBoxSelect'
import Pay from 'assets/svgs/Pay'
import Bill from 'assets/svgs/Bill'
import { createUseStyles } from 'react-jss'
import SelectBox, { SelectBoxOption } from 'components/SelectBox'
import { getDepositMonthsOptions } from 'helpers/warranty'
import StepButtons from '../../../../components/StepButtons'
import { STEPS } from 'constants/announcementSteps'

type Props = {
  property: PropertyAnnouncement
  onClickSave: (payload: Partial<PropertyAnnouncement>, nextStep: string) => void
  onPressBack: () => void
}

const WARRANTY_TYPE = {
  DEPOSIT: 'DEPOSIT',
  INSURANCE: 'INSURANCE',
}

const PropertyWarranty = (props: Props) => {
  const classes = useStyles(props)
  const { rent } = props.property.values
  const initialType = props.property.warranty.deposit_bond
    ? WARRANTY_TYPE.DEPOSIT
    : WARRANTY_TYPE.INSURANCE

  const depositMonthOptions = useMemo(() => getDepositMonthsOptions(rent), [rent])
  const [warrantyType, setWarrantyType] = useState(initialType)
  const [depositMonths, setDepositMonths] = useState(props.property.warranty.deposit_amount ?? 3)
  const [showDepositMonthsSelector, setShowDepositMonthsSelector] = useState(
    initialType === WARRANTY_TYPE.DEPOSIT,
  )

  const handleTypeSelect = (type: { id: string; label: string }) => {
    const isTypeDeposit = type.id === WARRANTY_TYPE.DEPOSIT
    setShowDepositMonthsSelector(isTypeDeposit)
    setWarrantyType(type.id)
  }

  const handleDepositMonthSelected = (option: SelectBoxOption) => {
    setDepositMonths(Number(option.id))
  }

  const handleSaveStep = () => {
    const payload = {
      warranty: {
        deposit_bond: warrantyType === WARRANTY_TYPE.DEPOSIT,
        deposit_amount: depositMonths,
        insurance_bond: warrantyType === WARRANTY_TYPE.INSURANCE,
      },
    }

    props.onClickSave(payload, STEPS.CONFIRMATION)
  }

  return (
    <div>
      <div className={classes.iconBoxContainer}>
        <IconBoxSelect
          onClick={handleTypeSelect}
          selectedId={warrantyType}
          options={[
            {
              id: 'DEPOSIT',
              label: 'Caução de Entrada',
              Icons: [{ Icon: Pay, id: 'Pay' }],
            },
            {
              id: 'INSURANCE',
              label: 'Seguro Fiança',
              Icons: [{ Icon: Bill, id: 'Bill' }],
            },
          ]}
        />
      </div>
      {showDepositMonthsSelector && (
        <div className={classes.depositMonthsContainer}>
          <SelectBox
            selected={depositMonths}
            options={depositMonthOptions}
            onClick={handleDepositMonthSelected}
          />
        </div>
      )}
      <WarrantySelector
        bondValue={rent}
        insuredDisplayValue={rent * 1.15}
        insuredReceivedValue={rent}
        values={props.property.values}
        tenantPays={props.property.tenant_pays}
      />

      <StepButtons onPressNext={handleSaveStep} onPressBack={props.onPressBack} />
    </div>
  )
}

const useStyles = createUseStyles({
  iconBoxContainer: {
    display: 'block',
    margin: '16px auto',
  },
  depositMonthsContainer: {
    margin: '16px auto',
  },
})

export default PropertyWarranty
